import { RevenueReportPayload } from "src/models/common.model";
import { urlReplace } from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function getRevenueReport(params: RevenueReportPayload) {
  return await apiCall.get(API_URL.REVENUE_REPORT.GET_REPORT, { ...params });
}
export async function getRevenueReportById(
  id: string,
  params: RevenueReportPayload
) {
  return await apiCall.get(API_URL.REVENUE_REPORT.GET_REPORT + "/" + id, {
    ...params,
  });
}

export async function getManualInvoiceRevenueReport(
  id: string,
  params: RevenueReportPayload
) {
  const url = urlReplace(
    API_URL.REVENUE_REPORT.GET_MANUAL_INVOICE_REPORT,
    "userUuid",
    id
  );
  return await apiCall.get(url, {
    ...params,
  });
}
